"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Routing = require("fos-routing");
// import file with routes data
var fos_js_routes_export_1 = require("./router/fos_js_routes_export");
// set data
Routing.setData(fos_js_routes_export_1.default);
// export library
exports.default = Routing;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuex-service-api/dist/Router.js
// module id = BX2f
// module chunks = 0